export let TimelineGridRootCssVars = /*#__PURE__*/function (TimelineGridRootCssVars) {
  TimelineGridRootCssVars["unitCount"] = "--unit-count";
  TimelineGridRootCssVars["rowCount"] = "--row-count";
  return TimelineGridRootCssVars;
}({});